import { Injectable } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CompetitionService } from 'app/services/competition.service';
import { Competition } from 'app/models/competition';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CompetitionsResolver implements Resolve<Competition[]> {
  constructor(private competitionService: CompetitionService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Competition[]> {
    const id = route.paramMap.get('id');
    return this.competitionService.getAll(id).map(res => {
      this.competitionService.setCompetitions(res);
      return res;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/competitions.guard.ts